import { render } from "./StatsBuilderElementsPanel.vue?vue&type=template&id=390858ba&scoped=true"
import script from "./StatsBuilderElementsPanel.vue?vue&type=script&lang=ts"
export * from "./StatsBuilderElementsPanel.vue?vue&type=script&lang=ts"

import "./StatsBuilderElementsPanel.vue?vue&type=style&index=0&id=390858ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-390858ba"

export default script